import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { CommonState } from "@obg/ngx.common";
import {
	AUTH_MESSAGE_CODES,
	AUTH_MESSAGE_CONTEXT,
	AUTH_TRANSACTION_CODES,
	AUTH_TRANSACTION_MESSAGE_CONTEXT,
	MessageService,
	MessageType,
	SessionSelector,
} from "@obg/ngx.core";
import { merge, Observable } from "rxjs";
import { filter, map, switchMap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class SgaVerificationService {
	constructor(
		private store: Store<CommonState>,
		private sessionSelector: SessionSelector,
		private messageService: MessageService
	) {}

	sgaVerification$(): Observable<void> {
		const loginFail$ = this.messageService
			.consume$({
				context: [AUTH_MESSAGE_CONTEXT.loginWithPersonalNumber, AUTH_MESSAGE_CONTEXT.login],
				messageType: MessageType.Error,
				messageCode: AUTH_MESSAGE_CODES.login.customerNotVerified,
			})
			.pipe(
				filter((messages) => messages && !!messages.length),
				switchMap(() => this.store.pipe(select(this.sessionSelector.getCustomerNotVerifiedData()))),
				filter((data) => !!data?.token),
				map(() => undefined)
			);

		const verificationStarted$ = this.messageService
			.consume$({
				context: AUTH_TRANSACTION_MESSAGE_CONTEXT.getVerificationStatus,
				messageType: MessageType.Info,
				messageCode: AUTH_TRANSACTION_CODES.verificationStatus.start,
			})
			.pipe(
				filter((messages) => messages && !!messages.length),
				map(() => undefined)
			);

		return merge(loginFail$, verificationStarted$);
	}
}
